import convertToArray from './convertToArray';
import StopScroll from './StopScroll';

class NewsDialog {
  init() {
    this.doc = document;
    this.dialogAttr = 'data-news-dialog';
    this.dialog = this.doc.querySelectorAll(`[${this.dialogAttr}]`);
    this.dialogLen = this.dialog.length;
    this.dialogActiveClass = 'is_active';
    this.closeBtnAttr = 'data-close-news';
    this.backdrop = this.doc.getElementById('backdrop');
    this.backdropActiveClass = 'is_active';
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.stopScroll = new StopScroll();
  }
  start() {
    this.btnAttr = 'data-open-news';
    this.btn = convertToArray(document.querySelectorAll(`[${this.btnAttr}]`));
    this.btnLen = this.btn.length;
    if (!this.btnLen) return;
    this.init();
    for (let bi = 0; bi < this.btnLen; bi += 1) {
      this.btn[bi].addEventListener('click', this.open);
    }
  }
  open(e) {
    this.currentNewsFlg = e.currentTarget.getAttribute(this.btnAttr);
    for (let di = 0; di < this.dialogLen; di += 1) {
      const dialog = this.dialog[di];
      // TODO 暫定的にデータ属性の値で開くダイアログを判定していますが、ダイアログの描画方法に合わせて修正をお願いします。
      if (dialog.getAttribute(this.dialogAttr) === this.currentNewsFlg) {
        this.openedDialog = dialog;
        this.openedDialog.classList.add(this.dialogActiveClass);
        this.backdrop.classList.add(this.backdropActiveClass);
        this.closeBtn = this.openedDialog.querySelector(`[${this.closeBtnAttr}]`);
        this.backdrop.addEventListener('click', this.close);
        this.closeBtn.addEventListener('click', this.close);
        this.stopScroll.stop();
      }
    }
  }
  close(e) {
    e.preventDefault();
    this.openedDialog.classList.remove(this.dialogActiveClass);
    this.backdrop.classList.remove(this.backdropActiveClass);
    this.backdrop.removeEventListener('click', this.close);
    this.closeBtn.removeEventListener('click', this.close);
    this.openedDialog = null;
    this.closeBtn = null;
    this.stopScroll.reStart();
  }
}
export default NewsDialog;



// WEBPACK FOOTER //
// ./src/js/module/NewsDialog.js